import {
  EverbeatApiClient,
  type EverbeatApiMap,
  EverbeatApiPackage,
  type IEverbeatApiClient,
} from '@kulak91/everbeat-api-client';

import { storage } from 'utils/storage/storage';
import { StorageKey } from 'types/enums';

class ApiClient implements EverbeatApiMap {
  #client: IEverbeatApiClient;

  constructor(baseUrl = 'http://localhost:8000') {
    this.#client = new EverbeatApiClient({
      baseUrl,
      tokenGetter: () => storage.get<string>(StorageKey.TOKEN),
      logLevel: 'debug',
    });
  }

  get accounts() {
    return this.#client.getApi(EverbeatApiPackage.accounts);
  }

  get patients() {
    return this.#client.getApi(EverbeatApiPackage.patients);
  }

  get firmware() {
    return this.#client.getApi(EverbeatApiPackage.firmware);
  }

  get ppg() {
    return this.#client.getApi(EverbeatApiPackage.ppg);
  }

  get ecg() {
    return this.#client.getApi(EverbeatApiPackage.ecg);
  }
}

export { ApiClient };
